import dynamicsCompressor from './dynamicsCompressor';
import gain from './gain';
import analyser from './analyser';

export default [
  dynamicsCompressor,
  gain,
  analyser
];
